import { withStyles, WithStyles } from "@mui/styles";
import boxStyle from "assets/jss/mui-extras/boxStyle";
import classNames from "classnames";
import { MuiColors } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";


interface IProps {
    border?: boolean;
    padding?: "1x" | "2x";
    variant: MuiColors;
};

type Props = IProps & WithStyles<typeof boxStyle>;

const MuiBox: React.FC<Props> = (props) => {
    const { border, classes, padding, variant, children } = props;

    const cls = classNames(
        {
            [classes[variant]]: variant,
            [classes.border]: border,
            [classes.padding1x]: padding == "1x",
            [classes.padding2x]: padding == "2x",
            [classes.root]: true
        }
    );

    return <div className={cls}>{children}</div>
}

MuiBox.defaultProps = {
    variant: "primary",
    border: true,
    padding: "2x"
}

export default withStyles(boxStyle)(MuiBox);
